import {
    getPermission,
    postPermission,
    putPermission,
    deletePermission,
} from "@services/account/permission";
import store from "@store/store";
import i18n from "@/i18n";

const state = {
    permissionHeader: [
        { text: "Id", value: "id", align: "left" },
        {
            text: i18n.t("permission.permissionName"),
            value: "permission_name",
            align: "left",
        },
        {
            text: i18n.t("common.table.createdAt"),
            value: "created_at",
            align: "left",
        },
        {
            text: i18n.t("common.table.updatedAt"),
            value: "updated_at",
            align: "left",
        },
        {
            text: i18n.t("common.table.actions"),
            value: "action",
            align: "left",
        },
    ],
    permissionData: [],
    loading: false,
    loadJson: true,
    permissionSettingInfo: {
        homeLoginDetailSummary: {
            label: i18n.t("permission.label.homeLoginDetailSummary"),
            tooltip: i18n.t("permission.tooltip.homeLoginDetailSummary"),
        },
        ibLoginDetailSummary: {
            label: i18n.t("permission.label.ibLoginDetailSummary"),
            tooltip: i18n.t("permission.tooltip.ibLoginDetailSummary"),
        },
        extraSymbolDetails: {
            label: i18n.t("permission.label.extraSymbolDetails"),
            tooltip: i18n.t("permission.tooltip.extraSymbolDetails"),
        },
        allowDownloadAll: {
            label: i18n.t("permission.label.allowDownloadAll"),
            tooltip: i18n.t("permission.tooltip.allowDownloadAll"),
        },
        ibExtraSymbolDetails: {
            label: i18n.t("permission.label.ibExtraSymbolDetails"),
            tooltip: i18n.t("permission.tooltip.ibExtraSymbolDetails"),
        },
        dailySummaryIcon: {
            label: i18n.t("permission.label.dailySummaryIcon"),
            tooltip: i18n.t("permission.tooltip.dailySummaryIcon"),
        },
        symbolLoginSwitch: {
            label: i18n.t("permission.label.symbolLoginSwitch"),
            tooltip: i18n.t("permission.tooltip.symbolLoginSwitch"),
        },
        mtdVolumeColumn: {
            label: i18n.t("permission.label.mtdVolumeColumn"),
            tooltip: i18n.t("permission.tooltip.mtdVolumeColumn"),
        },
        mtdPnlColumn: {
            label: i18n.t("permission.label.mtdPnlColumn"),
            tooltip: i18n.t("permission.tooltip.mtdPnlColumn"),
        },
        netEquityColumn: {
            label: i18n.t("permission.label.netEquityColumn"),
            tooltip: i18n.t("permission.tooltip.netEquityColumn"),
        },
        loginSummaryInfo: {
            label: i18n.t("permission.label.loginSummaryInfo"),
            tooltip: i18n.t("permission.tooltip.loginSummaryInfo"),
        },
        ibLoginSummaryInfo: {
            label: i18n.t("permission.label.ibLoginSummaryInfo"),
            tooltip: i18n.t("permission.tooltip.ibLoginSummaryInfo"),
        },
        loginSummaryStatistic: {
            label: i18n.t("permission.label.loginSummaryStatistic"),
            tooltip: i18n.t("permission.tooltip.loginSummaryStatistic"),
        },
        ibLoginSummaryStatistic: {
            label: i18n.t("permission.label.ibLoginSummaryStatistic"),
            tooltip: i18n.t("permission.tooltip.ibLoginSummaryStatistic"),
        },
        loginSummaryTrades: {
            label: i18n.t("permission.label.loginSummaryTrades"),
            tooltip: i18n.t("permission.tooltip.loginSummaryTrades"),
        },
        devSumUp: {
            label: i18n.t("permission.label.devSumUp"),
            tooltip: i18n.t("permission.tooltip.devSumUp"),
        },
        symbolSnapshot: {
            label: i18n.t("permission.label.symbolSnapshot"),
            tooltip: i18n.t("permission.tooltip.symbolSnapshot"),
        },
        loginSnapshot: {
            label: i18n.t("permission.label.loginSnapshot"),
            tooltip: i18n.t("permission.tooltip.loginSnapshot"),
        },
        ibLoginSummaryTrades: {
            label: i18n.t("permission.label.ibLoginSummaryTrades"),
            tooltip: i18n.t("permission.tooltip.ibLoginSummaryTrades"),
        },
        enableLP: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableLP"),
        },
        showEODPosition: {
            label: i18n.t("permission.label.showEODPosition"),
            tooltip: i18n.t("permission.tooltip.showEODPosition"),
        },
        lpDownloadAll: {
            label: i18n.t("permission.label.lpDownloadAll"),
            tooltip: i18n.t("permission.tooltip.lpDownloadAll"),
        },
        enableSearch: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableSearch"),
        },
        allowDownloadRequest: {
            label: i18n.t("permission.label.allowDownloadRequest"),
            tooltip: i18n.t("permission.tooltip.allowDownloadRequest"),
        },
        ibRelatedFieldsSearch: {
            label: i18n.t("permission.label.ibRelatedFieldsSearch"),
            tooltip: i18n.t("permission.tooltip.ibRelatedFieldsSearch"),
        },
        ibRelatedFieldsAlert: {
            label: i18n.t("permission.label.ibRelatedFieldsAlert"),
            tooltip: i18n.t("permission.tooltip.ibRelatedFieldsAlert"),
        },
        enableAlert: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableAlert"),
        },
        allowTickMutation: {
            label: i18n.t("permission.label.allowTickMutation"),
            tooltip: i18n.t("permission.tooltip.allowTickMutation"),
        },
        allowProfileCleanUp: {
            label: i18n.t("permission.label.allowProfileCleanUp"),
            tooltip: i18n.t("permission.tooltip.allowProfileCleanUp"),
        },
        alertConfig: {
            label: i18n.t("permission.label.alertConfig"),
            tooltip: i18n.t("permission.tooltip.alertConfig"),
        },
        brokerConfig: {
            label: i18n.t("permission.label.brokerConfig"),
            tooltip: i18n.t("permission.tooltip.brokerConfig"),
        },
        serverConfig: {
            label: i18n.t("permission.label.serverConfig"),
            tooltip: i18n.t("permission.tooltip.serverConfig"),
        },
        bookConfig: {
            label: i18n.t("permission.label.bookConfig"),
            tooltip: i18n.t("permission.tooltip.bookConfig"),
        },
        routingConfig: {
            label: i18n.t("permission.label.routingConfig"),
            tooltip: i18n.t("permission.tooltip.routingConfig"),
        },
        copyTradeConfig: {
            label: i18n.t("permission.label.copyTradeConfig"),
            tooltip: i18n.t("permission.tooltip.copyTradeConfig"),
        },
        alertConfigEdit: {
            label: i18n.t("permission.label.alertConfigEdit"),
            tooltip: i18n.t("permission.tooltip.alertConfigEdit"),
        },
        alertHubConfig: {
            label: i18n.t("permission.label.alertHubConfig"),
            tooltip: i18n.t("permission.tooltip.alertHubConfig"),
        },
        lpConfig: {
            label: i18n.t("permission.label.lpConfig"),
            tooltip: i18n.t("permission.tooltip.lpConfig"),
        },
        notificationConfig: {
            label: i18n.t("permission.label.notificationConfig"),
            tooltip: i18n.t("permission.tooltip.notificationConfig"),
        },
        accountPermission: {
            label: i18n.t("permission.label.accountPermission"),
            tooltip: i18n.t("permission.tooltip.accountPermission"),
        },
        accountManagement: {
            label: i18n.t("permission.label.accountManagement"),
            tooltip: i18n.t("permission.tooltip.accountManagement"),
        },
        accountConfig: {
            label: i18n.t("permission.label.accountConfig"),
            tooltip: i18n.t("permission.tooltip.accountConfig"),
        },
        accountProfile: {
            label: i18n.t("permission.label.accountProfile"),
            tooltip: i18n.t("permission.tooltip.accountProfile"),
        },
        enableK8s: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableK8s"),
        },
        enableCopyTrade: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableCopyTrade"),
        },
        enableChangeSummary: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableChangeSummary"),
        },
        enableAlertHub: {
            label: i18n.t("permission.label.enableAlertHub"),
            tooltip: i18n.t("permission.tooltip.enableAlertHub"),
        },
        enableAlertHubUpgrade: {
            label: i18n.t("permission.label.enableAlertHubUpgrade"),
            tooltip: i18n.t("permission.tooltip.enableAlertHubUpgrade"),
        },
        enableIBMonitor: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableIBMonitor"),
        },
        enableLoginMonitor: {
            label: i18n.t("common.form.enable"),
            tooltip: i18n.t("permission.tooltip.enableLoginMonitor"),
        },
        pkTaker: {
            label: i18n.t("permission.label.pkTaker"),
            tooltip: i18n.t("permission.tooltip.pkTaker"),
        },
        enableAlertMessagePumping: {
            label: i18n.t("permission.label.enableAlertMessagePumping"),
            tooltip: i18n.t("permission.tooltip.enableAlertMessagePumping"),
        },
        enableRiskRating: {
            label: i18n.t("permission.label.enableRiskRating"),
            tooltip: i18n.t("permission.tooltip.enableRiskRating"),
        },
        enableMarginAlertMessage: {
            label: i18n.t("permission.label.enableMarginAlertMessage"),
            tooltip: i18n.t("permission.tooltip.enableMarginAlertMessage"),
        },
        enablePositionRecMessage: {
            label: i18n.t("permission.label.enablePositionRecMessage"),
            tooltip: i18n.t("permission.tooltip.enablePositionRecMessage"),
        },
        enablePositionPNLMessage: {
            label: i18n.t("permission.label.enablePositionPNLMessage"),
            tooltip: i18n.t("permission.tooltip.enablePositionPNLMessage"),
        },
        enableIntradayRiskyAccount: {
            label: i18n.t("permission.label.enableIntradayRiskyAccount"),
            tooltip: i18n.t("permission.tooltip.enableIntradayRiskyAccount"),
        },
        enableLargeVolumeAlert: {
            label: i18n.t("permission.label.enableLargeVolumeAlert"),
            tooltip: i18n.t("permission.tooltip.enableLargeVolumeAlert"),
        },
        enableMarketNewsMessage: {
            label: i18n.t("permission.label.enableMarketNewsMessage"),
            tooltip: i18n.t("permission.tooltip.enableMarketNewsMessage"),
        },
        enableHourlyUpdatesMessage: {
            label: i18n.t("permission.label.enableHourlyUpdatesMessage"),
            tooltip: i18n.t("permission.tooltip.enableHourlyUpdatesMessage"),
        },
        enableLanguageSwitch: {
            label: i18n.t("permission.label.enableLanguageSwitch"),
            tooltip: i18n.t("permission.tooltip.enableLanguageSwitch"),
        },
        showAiAnalysisButton: {
            label: i18n.t("permission.label.showAiAnalysisButton"),
            tooltip: i18n.t("permission.tooltip.showAiAnalysisButton"),
        },
    },
};

const actions = {
    /**
     * Fetch configuration data
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  data    [data description]
     * @return  {[type]}          [return description]
     */
    getPermissionAction({ commit }) {
        commit("UPDATE_LOADING", true);
        commit("UPDATE_LOAD_JSON", false);
        getPermission().then((res) => {
            if (res.status === 200) {
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = i18n.t("permission.permissionLoaded");
            }
            const data = res.data;
            commit("GET_CONFIG_DATA", data);
            commit("UPDATE_LOADING", false);
            commit("UPDATE_LOAD_JSON", true);
        });
    },
    /**
     * Update permission
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  params  [params description]
     * @return  {[type]}          [return description]
     */
    putPermissionAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);
        if (
            state.permissionData.find((item) => item.id === params.id)
                .permission_name === params.permission_name
        ) {
            putPermission(params).then((res) => {
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = res.data.msg;
                commit("UPDATE_LOADING", false);
                dispatch("getPermissionAction");
            });
        } else {
            if (
                state.permissionData
                    .map((item) => item.permission_name)
                    .includes(params.permission_name)
            ) {
                store.state.snackcolor = "red";
                store.state.snackbar = true;
                store.state.snackmsg = i18n.t("permission.permissionExists");
                commit("UPDATE_LOADING", false);
            } else {
                putPermission(params).then((res) => {
                    store.state.snackcolor = "green";
                    store.state.snackbar = true;
                    store.state.snackmsg = res.data.msg;
                    commit("UPDATE_LOADING", false);
                    dispatch("getPermissionAction");
                });
            }
        }
    },
    /**
     * Create new permission
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  params  [params description]
     * @return  {[type]}          [return description]
     */
    postPermissionAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);

        if (
            state.permissionData
                .map((item) => item.permission_name)
                .includes(params.permission_name)
        ) {
            store.state.snackcolor = "red";
            store.state.snackbar = true;
            store.state.snackmsg = i18n.t("permission.permissionExists");
            commit("UPDATE_LOADING", false);
        } else {
            postPermission(params).then((res) => {
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = res.data.msg;
                commit("UPDATE_LOADING", false);
                dispatch("getPermissionAction");
            });
        }
    },
    deletePermissionAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);
        deletePermission(params)
            .then((res) => {
                commit("UPDATE_LOADING", false);
                store.state.snackcolor = "green";
                store.state.snackbar = true;
                store.state.snackmsg = res.data.msg;
                dispatch("getPermissionAction");
            })
            .catch(({ response }) => {
                store.state.snackcolor = "red";
                store.state.snackbar = true;
                store.state.snackmsg =
                    "Error " + response.status + ": " + response.data.msg;
                commit("UPDATE_LOADING", false);
            });
    },
};

const mutations = {
    /**
     * Update loading status
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    /**
     * Update load json
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOAD_JSON(state, data) {
        state.loadJson = data;
    },
    /**
     * Assign permission data after api request
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    GET_CONFIG_DATA(state, data) {
        state.permissionData = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
